import Component from './Component';

export default class ScrollComp extends Component {
  load() {
    let behaviorPref = 'auto';
    const isReduced = window.matchMedia(`(prefers-reduced-motion: reduce)`) === true || window.matchMedia(`(prefers-reduced-motion: reduce)`).matches === true;

    if (!!isReduced) {
      console.log('prefers-reduced-motion');
    } else {
      // console.log('set smooth scroll');
      behaviorPref = 'smooth';
    }

    const scrollbtn = document.querySelector('.scroll-comp');

    scrollbtn.addEventListener('click', () => {
      window.scroll(calcScrollAmount());
    });

    super.load();


    function calcScrollAmount() {
      const elFeatureBanner = document.querySelector('.featured-header__banner');
      const scrollYAmount = window.scrollY + elFeatureBanner.getBoundingClientRect().bottom;
      console.log('total height: ', scrollYAmount);

      const scrollOptions = {
        left: 0,
        top: scrollYAmount,
        behavior: behaviorPref
      };
      return scrollOptions;
    }

    // Can't scroll perfectly if their isn't enough room on page.
  }
}
